import React from 'react';
import { useBooking } from '../../context/BookingContext';
import { formatCurrency, formatDate, formatDateTime } from '../../utils/formatCurrency';
import './FareSummary.css';

const FareSummary = () => {
  const { booking } = useBooking();
  const vehicle = booking.selectedVehicle || booking.selectedPackage;
  const isRental = booking.tripType === 'rental';
  const isPayAfterTrip = isRental || booking.tripType === 'instant';
  const baseFare =
    vehicle?.total_price ?? vehicle?.package_price ?? 0;
  const taxes = 0;
  const total = baseFare + taxes;

  return (
    <aside className="fs-card">
      <h3 className="fs-title">Trip Summary</h3>

      <div className="fs-section">
        <Row
          label="Ride mode"
          value={booking.tripType === 'rental'
            ? 'Rental'
            : booking.tripType === 'instant'
              ? 'Instant'
              : 'Outstation'}
        />
        {booking.tripType === 'outstation' && (
          <Row label="Trip type" value={booking.rideMode === 'round_trip' ? 'Round trip' : 'One way'} />
        )}
        <Row label="Pickup" value={booking.pickup?.name || '—'} />
        {booking.dropoff?.name && (
          <Row label="Drop" value={booking.dropoff.name} />
        )}
        <Row label="Date" value={formatDate(booking.date)} />
        {booking.returnDate && (
          <Row label="Return" value={formatDateTime(booking.returnDate)} />
        )}
        {vehicle && (
          <Row label="Vehicle" value={vehicle.vehicle_type} />
        )}
        {vehicle?.distance_km && (
          <Row label="Distance" value={`${Number(vehicle.distance_km).toFixed(0)} KM`} />
        )}
        {vehicle?.included_km && (
          <Row label="Included" value={`${vehicle.included_km} KM`} />
        )}
        {vehicle?.included_hours && (
          <Row label="Included time" value={`${vehicle.included_hours} hours`} />
        )}
      </div>

      {isPayAfterTrip ? (
        <div className="fs-rental-note">
          <strong>Pay after your trip</strong>
          <span>
            {isRental
              ? 'Your rental fare will be payable after the trip is completed.'
              : `Estimated fare ${formatCurrency(baseFare)} will be payable after the ride is completed.`}
          </span>
        </div>
      ) : (
        <>
          <hr />

          <div className="fs-section">
            <Row label="Base Fare" value={formatCurrency(baseFare)} />
            <Row label="Taxes" value={formatCurrency(taxes)} />
          </div>

          <hr />

          <div className="fs-total">
            <span>Total</span>
            <strong>{formatCurrency(total)}</strong>
          </div>
        </>
      )}
    </aside>
  );
};

const Row = ({ label, value }) => (
  <div className="fs-row">
    <span>{label}</span>
    <span className="fs-value">{value}</span>
  </div>
);

export default FareSummary;